import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {AccountsListService} from "../ListOfAccounts/AccountsListService";
import {css} from "@emotion/css";
import * as React from "react";
import {useEffect, useState} from "react";
import {RaikoButtonPrimary, RaikoGridOneColumn} from "@moeindal/base-raiko-panel-components";
import axios from "axios";
import {HttpClient} from "../../service/httpClient/HttpClient";

export default function TransactionReceipt({info,handleUpdateTable}) {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new AccountsListService(fundID, token, snackbar, loading)

    const [imageFile, setImageFile] = useState();
    const [imageName, setImageName] = useState();
    const [image, setImage] = useState("");
    const [loadingState, setLoadingState] = useState(false)

    const [receiptImageFile, setReceiptImageFile] = useState();


    useEffect(async () => {

        if (typeof info && info.receiptUrl) {

            loading(setLoadingStateDispatch(true))
            try {
                // fetch your file
                const response = await axios.get(info.receiptUrl, {
                    headers: new HttpClient().prepareUserAccessHeader(token),
                    responseType: "arraybuffer",
                });

                const file = new Blob([response.data], {
                    type: "image/(png|jpeg|jpg)",
                });
                const objectURL = URL.createObjectURL(file);
                setReceiptImageFile(objectURL)

                loading(setLoadingStateDispatch(false))
            } catch (e) {

                loading(setLoadingStateDispatch(false))
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در نمایش رسید پرداخت!"))
            }
        }
    }, [info])

    function uploadReceiptImageFile({target: {files}}) {
        if (typeof files[0] !== 'undefined') {
            setImageFile(files[0])
            setImageName(files[0].name)
            setImage(URL.createObjectURL(files[0]))


        }
    }


    function handleUpdateReceipt() {
        if (imageFile) {
            setLoadingState(true)
            service.updateMonthlyDepositReceipt(fundID, info.id, imageFile)
                .then(response => {
                    snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "بروزرسانی با موفقیت انجام شد."))
                    handleUpdateTable()
                }).catch(reason => {
                showServerError(reason)
            }).finally(_ => {
                setLoadingState(false)
            })
        } else
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "لطفا تصویر مورد نظر را انتخاب نمایید."))
    }

    function showServerError(reason) {
        if (reason.response && reason.response.data.message)
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, reason.response.data.message))
        else
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطایی رخ داده، لطفا مجددا تلاش نمایید."))
    }

    return (
        <>
            <input
                type="file"
                id="receiptImageFile"
                hidden={true}
                multiple={true}
                accept="image/png,image/gif,image/jpeg"
                onChange={uploadReceiptImageFile}
            />
            <RaikoGridOneColumn className={`${css`margin: 0 1rem .5rem 1rem;`}`}>
                <div className={`uploadImageContent`}
                     onDragOver={event => {
                         event.stopPropagation();
                         event.preventDefault();
                         event.dataTransfer.dropEffect = 'copy';
                     }}
                     onDrop={event => {
                         event.stopPropagation();
                         event.preventDefault();
                         uploadReceiptImageFile({target: {files: event.dataTransfer.files}})
                     }}
                     id="uploadImageContent">
                    <div className="d-flex alignItemsCenter">
                        {
                            image ?
                                <img
                                    className={css`
                                      object-fit: fill;
                                      max-width: 100px;
                                      max-height: 100px;
                                    `}
                                    src={image}
                                    id={"image"}
                                    alt="receiptImageFile"/> :
                                receiptImageFile ?
                                    <img
                                        className={css`
                                          object-fit: fill;
                                          max-width: 100px;
                                          max-height: 100px;
                                        `}
                                        src={receiptImageFile}
                                        id={"image"}
                                        alt="receiptImageFile"/>
                                    :
                                    <div className="ic-picture"/>
                        }
                        <div className="upload-text-content">
                            <span className="upload-text">آپلود تصویر</span>
                            <span className="drop-down-text">تصویر رسید تراکنش را انتخاب نمایید.</span>
                        </div>
                    </div>
                    <button
                        className="btn-confirm"
                        onClick={_ => document.getElementById("receiptImageFile").click()}
                    >
                        انتخاب فایل
                    </button>
                </div>
                <div className={css`
                  display: flex;
                  justify-content: end;`}
                >
                    <RaikoButtonPrimary loading={loadingState} label={"بروزرسانی"} onClick={handleUpdateReceipt}/>
                </div>
            </RaikoGridOneColumn>

        </>
    )

}
